import React, { useEffect, useState } from "react";
import { Table, Button } from "antd"; // Import Button from Ant Design

function TentHouseDetails({ allData }) {
  console.log(allData)
  const [data, setData] = useState([]);
  // const [expandedRows, setExpandedRows] = useState({}); // State to manage visibility of data per shop

  useEffect(() => {
    setData(allData);
  }, [allData]);

  // Define columns for the main grocery details table
  const groceryColumns = [
    {
      title: "Name",
      dataIndex: ["shop", "name"],
      key: "name",
    },
    {
      title: "People Count",
      dataIndex: ["shop", "peopleCount"],
      key: "peopleCount",
    },
    {
      title: "Gross Profit",
      dataIndex: ["shop", "grossReceipt"],
      key: "grossReceipt",
    },
    {
      title: "Gathering Charged",
      dataIndex: ["shop", "gatheringCharged"],
      key: "gatheringCharged",
    },
  ];

  // Define columns for the items table
  const itemColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "Purchase",
      dataIndex: "purchase",
      key: "purchase",
    },
    {
      title: "Depression",
      dataIndex: "depression",
      key: "depression",
    },
    {
      title: "Durability",
      dataIndex: "durability",
      key: "durability",
    },
    {
      title: "Tent House",
      dataIndex: "tentHouse",
      key: "tentHouse",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
  ];

  // Define columns for the labours table
  const labourColumns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Payout",
      dataIndex: "payout",
      key: "payout",
    },
    {
      title: "Count",
      dataIndex: "count",
      key: "count",
    },
    {
      title: "Created At",
      dataIndex: "created",
      key: "created",
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        {data && data.length > 0 ? (
          data.map((shopData, index) => (
            <div key={index} className="col-12 mb-4">
              <h5 className="mb-2">{shopData?.shop?.name}</h5>
                <p className="mb-1">People Count: {shopData?.shop?.peopleCount}</p>
                <p className="mb-1">Gross Profit: {shopData?.shop?.grossReceipt}</p>
                <p className="mb-1">Gatering Charged: {shopData?.shop?.gatheringCharged}</p>
              <div className="card shadow-sm">
                <div className="card-body">
                  {/* <div className="table-responsive mt-4">
                    <Table
                      dataSource={[shopData]}
                      columns={groceryColumns}
                      pagination={false}
                      rowKey={(record) => record.shop.name}
                    />
                  </div> */}
                  {shopData.items && shopData.items.length > 0 && (
                    <div className="table-responsive mt-4">
                      <h6 className="text-danger">Items</h6>
                      <Table
                        dataSource={shopData?.items}
                        columns={itemColumns}
                        pagination={false}
                        rowKey={(record) => record.name + record.quantity + record.purchase} // Unique key for each item
                      />
                      {/* {shopData.items.length > 3 && (
                        <Button
                          onClick={() => setExpandedRows((prev) => ({
                            ...prev,
                            [index]: { items: !prev[index]?.items }
                          }))}
                          className="mt-2"
                        block>
                          {expandedRows[index]?.items ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  )}
                  {shopData.labours && shopData.labours.length > 0 && (
                    <div className="table-responsive mt-4">
                      <h6 className="text-danger">Labours:</h6>
                      <Table
                        dataSource={shopData.labours}
                        columns={labourColumns}
                        pagination={false}
                        rowKey={(record) => record.name + record.payout + record.count} // Unique key for each labour
                      />
                      {/* {shopData.labours.length > 3 && (
                        <Button
                          onClick={() => setExpandedRows((prev) => ({
                            ...prev,
                            [index]: { labours: !prev[index]?.labours }
                          }))}
                          className="mt-2"
                       block >
                          {expandedRows[index]?.labours ? 'Show Less' : 'View All'}
                        </Button>
                      )} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12">
            <div className="card text-center">
              <div className="card-body">
                <p className="text-muted">No data available</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TentHouseDetails;
